/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentityProviderSettingsFormConfiguration,
    IdentityProviderSettingsFormConfigurationFromJSON,
    IdentityProviderSettingsFormConfigurationToJSON,
    IdentityProviderSettingsFormData,
    IdentityProviderSettingsFormDataFromJSON,
    IdentityProviderSettingsFormDataToJSON,
    IdentityProviderSettingsValidationData,
    IdentityProviderSettingsValidationDataFromJSON,
    IdentityProviderSettingsValidationDataToJSON,
} from '../models';

export interface ApiIdentityProviderSettingsIdentityProviderSettingsFormConfigurationGetRequest {
    providerId?: string;
}

export interface ApiIdentityProviderSettingsIdentityProviderSettingsFormCreatePostRequest {
    identityProviderSettingsFormData?: IdentityProviderSettingsFormData;
}

export interface ApiIdentityProviderSettingsIdentityProviderSettingsFormDataGetRequest {
    id?: string;
}

export interface ApiIdentityProviderSettingsIdentityProviderSettingsFormIdDeleteRequest {
    id: string;
}

export interface ApiIdentityProviderSettingsIdentityProviderSettingsFormUpdatePostRequest {
    identityProviderSettingsFormData?: IdentityProviderSettingsFormData;
}

export interface ApiIdentityProviderSettingsIdentityProviderSettingsFormValidatePostRequest {
    identityProviderSettingsFormData?: IdentityProviderSettingsFormData;
}

/**
 * no description
 */
export class IdentityProviderSettingsFormApi extends runtime.BaseAPI {

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormConfigurationGetRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormConfigurationGetRequest): Promise<runtime.ApiResponse<IdentityProviderSettingsFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.providerId !== undefined) {
            queryParameters['providerId'] = requestParameters.providerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityProviderSettingsFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormConfigurationGet(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormConfigurationGetRequest): Promise<IdentityProviderSettingsFormConfiguration> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormCreatePostRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityProviderSettingsFormDataToJSON(requestParameters.identityProviderSettingsFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormCreatePost(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormCreatePostRequest): Promise<string> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormDataGetRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormDataGetRequest): Promise<runtime.ApiResponse<IdentityProviderSettingsFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityProviderSettingsFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormDataGet(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormDataGetRequest): Promise<IdentityProviderSettingsFormData> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormIdDeleteRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiIdentityProviderSettingsIdentityProviderSettingsFormIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsForm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormIdDelete(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormIdDeleteRequest): Promise<void> {
        await this.apiIdentityProviderSettingsIdentityProviderSettingsFormIdDeleteRaw(requestParameters);
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormUpdatePostRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityProviderSettingsFormDataToJSON(requestParameters.identityProviderSettingsFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormUpdatePost(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormUpdatePostRequest): Promise<void> {
        await this.apiIdentityProviderSettingsIdentityProviderSettingsFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormValidatePostRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormValidatePostRequest): Promise<runtime.ApiResponse<IdentityProviderSettingsValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityProviderSettingsFormDataToJSON(requestParameters.identityProviderSettingsFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityProviderSettingsValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsFormValidatePost(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsFormValidatePostRequest): Promise<IdentityProviderSettingsValidationData> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
